import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "lnr-apartment FilterIcon" }, null, -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "Title" }, "Attendance", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "Badge"
}
const _hoisted_4 = { class: "RefineContentOptionsList" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["AttendanceFilterWrapper", { 'is-collapsed': _ctx.collapsed }])
  }, [
    _createElementVNode("header", {
      class: "RefineSectionHeading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFilter()))
    }, [
      _hoisted_1,
      _hoisted_2,
      (_ctx.filterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIcon", [_ctx.collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']])
      }, null, 2 /* CLASS */)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createVNode(_component_Checkbox, {
            filterKey: _ctx.key,
            optionName: item.optionName,
            optionValue: item.optionValue
          }, null, 8 /* PROPS */, ["filterKey", "optionName", "optionValue"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 2 /* CLASS */))
}